const urlCleanRegex = /[\W_]+/g;

/**
 * Builds the SEO slug path segments for a listing/boondocking detail route
 * (`/rv-camping/:location/:name/:id` or `/boondocking/:location/:name/:id`),
 * matching the shape `serverless/sitemap/sitemap-generator.js` already
 * generates. `location`/`name` are omitted when the source data is missing,
 * which is why the router registers `:location/:name/:id`, `:name/:id`, and
 * bare `:id` as sibling routes.
 */
export function buildListingSlugSegments(
  prefix: 'rv-camping' | 'boondocking',
  entry: { id: number; title: string; city?: string; state?: string },
): string[] {
  const segments: string[] = ['', prefix];
  if (entry.city?.trim() && entry.state?.trim()) {
    segments.push(
      encodeURIComponent(
        `${entry.city.replace(urlCleanRegex, '-')}_${entry.state.replace(urlCleanRegex, '-')}`,
      ).toLowerCase(),
    );
  }
  if (entry.title) {
    segments.push(encodeURIComponent(entry.title.replace(urlCleanRegex, '-')).toLowerCase());
  }
  if (entry.id) {
    segments.push(entry.id.toString());
  }
  return segments;
}
